// Lazy page components for the root-scope procurement routes.
//
// Split out of procurementRoutes.tsx purely so each module has ONE kind of
// export: this file exports only components, that one only route builders.
// A module that mixes the two breaks Vite fast refresh, which is what
// react-refresh/only-export-components reports — the same 59 errors
// routes/groupRouteAliases.tsx carries today. New files start clean.

import { lazy } from 'react'

export const RFQsPage = lazy(() => import('@/pages/Procurement/RFQsPage'))
export const RFQCreatePage = lazy(() => import('@/pages/Procurement/RFQCreatePage'))
export const RFQDetailPage = lazy(() => import('@/pages/Procurement/RFQDetailPage'))
